import { NodeType } from '@getaccept/editor-lib-new';
import type { ContractLink } from '@getaccept/editor-lib-new';
import type { Page } from '../';

export const hiddenSectionsOrEmptyContractLinks = (page: Page) =>
  page.editorBlock.content.sections.some(
    section =>
      !section.hidden &&
      section.rows.some(row =>
        row.cells.some(cell =>
          cell.nodes.some(
            (node: ContractLink) => node.type !== NodeType.ContractLink || node.contractId
          )
        )
      )
  );
